'use client'

import { useState } from 'react'
import { Plus, Minus } from 'lucide-react'

interface Props {
  question: string
  answer: string
}

export function FAQItem({ question, answer }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <div style={{ borderBottom: '1px solid #E9E5DC' }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '18px 0',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
          gap: 16,
        }}
        aria-expanded={open}
      >
        <span
          style={{
            fontFamily: 'var(--font-bricolage)',
            fontSize: 15,
            fontWeight: 600,
            color: '#141410',
            lineHeight: 1.4,
          }}
        >
          {question}
        </span>
        <span style={{ color: '#3A8C56', flexShrink: 0 }}>
          {open ? <Minus size={18} /> : <Plus size={18} />}
        </span>
      </button>

      <div
        style={{
          maxHeight: open ? 300 : 0,
          overflow: 'hidden',
          transition: 'max-height 0.38s ease',
        }}
      >
        <p
          style={{
            fontSize: 14,
            color: '#6A675E',
            lineHeight: 1.8,
            paddingBottom: 20,
          }}
        >
          {answer}
        </p>
      </div>
    </div>
  )
}
